import { render, staticRenderFns } from "./GroupBookingDetails.vue?vue&type=template&id=67de2c32&scoped=true&"
import script from "./GroupBookingDetails.vue?vue&type=script&lang=js&"
export * from "./GroupBookingDetails.vue?vue&type=script&lang=js&"
import style0 from "./GroupBookingDetails.vue?vue&type=style&index=0&id=67de2c32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67de2c32",
  null
  
)

export default component.exports